import { CatalogFilters } from '../../types'
import {
  CatalogFilterAction,
  CatalogFilterActions,
  CatalogFilterActionAddFilter,
  FILTERS_INITIAL_DATA
} from './context'

export function reducer(state, action: CatalogFilterAction) {
  switch (action.type) {
    case CatalogFilterActions.setFiltersShown:
      return {
        ...state,
        filtersShown: action.payload
      }
    case CatalogFilterActions.setClosedManually:
      return {
        ...state,
        filtersClosedManually: Array.from(new Set([...state.filtersClosedManually, action.payload]))
      }
    case CatalogFilterActions.clearCloseManually:
      return {
        ...state,
        filtersClosedManually: []
      }
    case CatalogFilterActions.setFilters:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...(action.payload as Partial<CatalogFilters>)
        }
      }
    case CatalogFilterActions.addFiltersValue: {
      const payload = action.payload as CatalogFilterActionAddFilter
      return {
        ...state,
        filters: {
          ...state.filters,
          [payload.filterId]: [...state.filters[payload.filterId], payload.value]
        }
      }
    }
    case CatalogFilterActions.clearFilters: {
      return {
        ...state,
        filters: FILTERS_INITIAL_DATA.state.filters
      }
    }
    case CatalogFilterActions.clearAll: {
      return {
        ...state,
        filters: FILTERS_INITIAL_DATA.state.filters,
        fullTextSearch: ''
      }
    }
    case CatalogFilterActions.setPage: {
      return {
        ...state,
        page: action.payload
      }
    }
    case CatalogFilterActions.setFullTextSearch:
      return {
        ...state,
        fullTextSearch: action.payload
      }
    case CatalogFilterActions.setOrderBy:
      return {
        ...state,
        orderBy: action.payload
      }
    case CatalogFilterActions.setSubscribedBy:
      return {
        ...state,
        subscribedBy: action.payload
      }
    default:
      return state
  }
}
